import './Logo.css';

interface Props {
  compact?: boolean;
}

export function Logo(props: Props) {
  return (
    <a
      href="/"
      class="logo"
      aria-label="Концепт 13 — на главную"
      classList={{ 'logo--compact': props.compact }}
    >
      <img src="/logo.jpg" alt="" width="48" height="48" class="logo__mark" />
      <span class="logo__text">
        <span class="logo__name">Концепт 13</span>
        <span class="logo__caption">Агрегаты · запчасти</span>
      </span>
    </a>
  );
}
